export default "__VITE_ASSET__B0NOxW_X__"